import { COURSE_TYPES } from '@shared/Resources/types';

export default COURSE_TYPES;

